import { useCallback } from 'react';
import type { AuthorizationParams } from '@auth0/auth0-react';
import { useAuth0 } from '@auth0/auth0-react';

import { setViewOnlyCookie } from '@crossnokaye/ux-common';

/**
 * Login-redirect trigger that returns the user to the current page (path + query +
 * hash) after the Auth0 round-trip, via appState.returnTo.
 *
 * Clears the shared `ck.viewOnly` signal first so every interactive login lands active
 * (the post-login reconcile mints write, not read-only). Local clear only — no cross-app
 * broadcast, since we haven't re-authenticated yet.
 */
export const useLoginAndReturn = () => {
  const { loginWithRedirect } = useAuth0();

  return useCallback(
    (authorizationParams?: AuthorizationParams) => {
      setViewOnlyCookie(false);
      return loginWithRedirect({
        ...(authorizationParams ? { authorizationParams } : {}),
        appState: {
          returnTo: window.location.pathname + window.location.search + window.location.hash,
        },
      });
    },
    [loginWithRedirect]
  );
};
